import React, { useState } from "react";
import apiClient from "../api/client";

export default function FeedbackButton() {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("feature");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    setError("");
    setSending(true);
    try {
      await apiClient.post(`/auth/feedback`, { type, message: message.trim() });
      setSent(true);
      setMessage("");
      setTimeout(() => {
        setSent(false);
        setOpen(false);
      }, 1500);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="feedback-float">
      {open && (
        <div className="feedback-panel">
          <div className="feedback-panel-header">
            <span className="feedback-panel-title">שליחת משוב</span>
            <button
              type="button"
              className="feedback-close"
              onClick={() => setOpen(false)}
              aria-label="סגור"
            >
              ×
            </button>
          </div>
          <form onSubmit={handleSubmit} className="feedback-form">
            <div className="field">
              <label className="label">סוג</label>
              <select
                className="select"
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="feature">בקשת פיצ'ר</option>
                <option value="bug">דיווח באג</option>
              </select>
            </div>
            <div className="field">
              <label className="label">הודעה</label>
              <textarea
                className="input textarea"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="תאר את הבקשה או את הבעיה..."
                rows={4}
                required
              />
            </div>
            {error && <p className="message-error" style={{ marginBottom: "var(--space-sm)" }}>{error}</p>}
            {sent && <p className="message-success" style={{ marginBottom: "var(--space-sm)" }}>נשלח בהצלחה</p>}
            <button type="submit" className="btn btn-primary" disabled={sending}>
              {sending ? "שולח..." : "שליחה"}
            </button>
          </form>
        </div>
      )}
      <button
        type="button"
        className="feedback-trigger"
        onClick={() => setOpen((o) => !o)}
        title="שליחת משוב / דיווח באג"
        aria-label="פתח שליחת משוב"
      >
        <span className="feedback-trigger-icon">💬</span>
        <span className="feedback-trigger-label">משוב</span>
      </button>
    </div>
  );
}
